import React, { useEffect } from 'react'
import EstimatedPriceResultContent from '../components/EstimatedPriceResultContent'
import { setupEstimateResult } from '../lib/estimateResultAnimations'

const EstimatedPriceResult = () => {
  useEffect(() => {
    const teardown = setupEstimateResult()
    return () => teardown?.()
  }, [])

  return (
    <div className="brand-fonts bg-white">
      <EstimatedPriceResultContent />
    </div>
  )
}

export default EstimatedPriceResult
